import { render } from "./Warning.vue?vue&type=template&id=cf282820"
import script from "./Warning.vue?vue&type=script&lang=js"
export * from "./Warning.vue?vue&type=script&lang=js"

import "./Warning.vue?vue&type=style&index=0&id=cf282820&lang=scss"
script.render = render

export default script